import React from "react";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import bgImage from "../Assets/IMG/BG_03.gif";

const stats = [
  {
    value: 3,
    suffix: "X",
    label: "Brand Evolution Boost",
    Discription: "Like Tony Stark upgrading suits — we evolve brands, fast",
  },
  {
    value: 120,
    suffix: "+",
    label: "Alliances Forged",
    Discription: "Not sidekicks, actual business partners we've powered with strategy",
  },
  {
    value: 100,
    suffix: "M+",
    label: "Organic Impressions Assembled",
    Discription: "No Infinity Stones, just pure content firepower across platforms",
  },
  {
    value: 10000,
    suffix: "+",
    label: "Reels Shot & Edited with Precision",
    Discription: "That’s more cuts than Deadpool’s comebacks — from shoot to viral",
  },
];

const StatsCards = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.3 });

  return (
    <div
      ref={ref}
      style={{
        padding: "5% 0",
        width: "100%",
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <h1 style={{ fontSize: "30px", textAlign: "center", color: "#000" }}>
        S.H.I.E.L.D.Grade Stats from Glowingrowth Media (GGM)
        <br />
        Because even the Avengers rely on performance reports
      </h1>

      <div style={{ maxWidth: "1300px", margin: "5% auto", padding: "0 16px" }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
            gap: "32px",
          }}
        >
          {stats.map((stat, index) => (
            <div
              key={index}
              style={{
                backgroundColor: "#FAFAFA",
                borderRadius: "20px",
                boxShadow: "0 10px 20px rgba(0,0,0,0.1)",
                padding: "40px 20px",
                textAlign: "center",
                transition: "all 0.5s ease",
                transform: "scale(1)",
                cursor: "pointer",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.05)";
                e.currentTarget.style.boxShadow = "0 12px 30px rgba(0, 0, 0, 0.2)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.boxShadow = "0 10px 20px rgba(0, 0, 0, 0.1)";
              }}
            >
              <div style={{ fontSize: "36px", fontWeight: "bold", color: "#111827" }}>
                {inView ? <CountUp end={stat.value} duration={60} /> : "0"}
                {stat.suffix}
              </div>
              <div style={{ marginTop: "8px", fontSize: "18px", color: "#000", fontWeight: "bold" }}>
                {stat.label}
              </div>
              <div style={{ marginTop: "12px", fontSize: "14px", color: "#000" }}>
                {stat.Discription}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StatsCards;
